import { styled } from 'stitches.config'
import { CollapsibleMenu } from 'features/components/CollapsibleMenu'
import { Content } from 'features/components/CollapsibleMenu/CollapsibleMenu.styles'

export const StyledCollapsibleMenu = styled(CollapsibleMenu, {
  width: '100%',

  [`& > ${Content}`]: {
    paddingBottom: '$3',
  },
})
